import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, ValidationRuleType } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-number-decimal',
  templateUrl: './d-con-number-decimal.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DConNumberDecimalComponent),
      multi: true
    }
  ]
})
export class DConNumberDecimalComponent extends DynamicComponentBase {
  static KEY = 'd-con-number-decimal';

  // @HostBinding('style.float') float = 'left';
  ruleType = ValidationRuleType;

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.step !== 'number') {
      config.step = 1;
    }
    if (!config.effective) {
      config.effective = [];
    }
  }
}
